/**
 * Csv Schema of WebserviceIntegracao
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {WebserviceIntegracao} from '@/model/resource/WebserviceIntegracao'

/* TODO: review generated schema */
export class CsvWebserviceIntegracaoSchema extends Schema {
  readonly name = 'CsvWebserviceIntegracao'

  readonly fieldSet: FieldSet<WebserviceIntegracao> = {
    path: schema => schema.model.path,
  }
}
